module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/vi/2-60af10cf82b6919ce5f4cb39775781d7.jpg";